import Snappy from '../../../libs/snappy/snappy';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import $ from 'jquery';


Snappy.Component.IrTrigger = class IrTrigger extends Snappy.BaseComponent {
    static get tagName() {
        return 'ir-trigger';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

    }

    setVars() {
        this.type = this.$element.data('type') || 'signin';


    }
    setEventListeners() {
        if (!IrTrigger.$container) {
            return;
        }

        this.$element.on('click', this.clickHandle.bind(this));
    }

    clickHandle() {
        switch (this.type) {
            case 'signin':
                IrTrigger.openSinginIr();
                break;
            case 'registration':
                IrTrigger.openRegistrationIr();
                break;
            default:
                console.log('wrong type');
        }
    }

     static openSinginIr() {
         const url = IrTrigger.$container.attr("irUrl");
         IrTrigger.openIR(url);

    }

    static openRegistrationIr() {
        const url = IrTrigger.$container.attr("irRegUrl");
        IrTrigger.openIR(url);
    }

    static openIR(url) {
        $("#IrSignInModal").on("show.bs.modal", function() {
            $("#IRFrame").attr("src", url);
            $("#IrSignInModal").css("padding", "0px")
        });

        $("#IrSignInModal").modal({
            show: true
        });
        $(".modal-backdrop.in").hide();
        $("#follow-register-modal-block").modal("hide");
    }

    static get $container() {
        return $(".ir-frame-container");
    }

}

$(window).on('IR:openSingIn', Snappy.Component.IrTrigger.openSinginIr);



// WEBPACK FOOTER //
// ./components/ir-trigger/scripts/ir-trigger.js